import { useState } from "react";
import { useGroupEntitiesQuery } from "../../processingActivity/hooks/useGroupEntitiesQuery.ts";
import { GroupCompaniesFieldProps } from "./GroupCompaniesField.tsx";

export function requiresGroupCompanySelection(allGroupEntityAccess: boolean, groupEntities: Array<string>, requireSelectionBeforeUncheck: boolean) {
    return requireSelectionBeforeUncheck && !allGroupEntityAccess && groupEntities.length === 0;
}

export function useGroupCompaniesField(props: GroupCompaniesFieldProps) {
    const groupEntityQuery = useGroupEntitiesQuery(!props.isPreview);
    const [showSelectorDialog, setShowSelectorDialog] = useState(false);
    const [entitiesSelectedInDialog, setEntitiesSelectedInDialog] = useState<Array<string>>([]);
    const [dialogGridLength, setDialogGridLength] = useState(10);

    const hasMultipleGroupEntities = (groupEntityQuery.allGroupEntities?.length ?? 0) > 1;

    function onAllGroupEntityAccessChange(allGroupEntityAccess: boolean) {
        if (requiresGroupCompanySelection(allGroupEntityAccess, props.groupEntities, props.requireSelectionBeforeUncheck)) {
            setEntitiesSelectedInDialog([]);
            setShowSelectorDialog(true);
            return;
        }

        props.onChange({ groupEntities: props.groupEntities, allGroupEntityAccess });
    }

    function onGroupEntitiesChange(groupEntities: Array<string>) {
        props.onChange({ groupEntities, allGroupEntityAccess: props.allGroupEntityAccess });
    }

    function onSelectorDialogConfirm() {
        props.onChange({ groupEntities: entitiesSelectedInDialog, allGroupEntityAccess: false });
    }

    return {
        allGroupEntities: groupEntityQuery.allGroupEntities,
        isLoading: groupEntityQuery.isLoading || props.isLoading,
        show: props.isPreview || hasMultipleGroupEntities,
        showTable: props.isPreview || !props.allGroupEntityAccess,
        // onSelectorDialogConfirm needs no readOnly guard, it is only reachable through the gated toggle
        onAllGroupEntityAccessChange: props.readOnly ? () => {} : onAllGroupEntityAccessChange,
        onGroupEntitiesChange: props.readOnly ? () => {} : onGroupEntitiesChange,
        showSelectorDialog,
        setShowSelectorDialog,
        entitiesSelectedInDialog,
        setEntitiesSelectedInDialog,
        dialogGridLength,
        setDialogGridLength,
        onSelectorDialogConfirm,
    };
}
